import authConfig from "src/configs/auth";

/** localStorage key: set when guide finishes; cleared on logout → guide runs every login, not every refresh. */
export const userGuideStorageKey = (userId) => `beemz_userGuide_seen_${userId}`;

/** Resolve stable user id for guide storage (API may use _id or id). */
export function resolveUserGuideUserId(user) {
  if (!user) return null;
  if (user._id) return user._id;
  if (user.id) return user.id;
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(authConfig.storageUserIdKeyName);
}

/** Call on logout so the next login runs the user guide again. */
export function clearUserGuideCompletion(user) {
  const uid = resolveUserGuideUserId(user);
  if (!uid || typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(userGuideStorageKey(uid));
  } catch {
    /* ignore */
  }
}
